import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import config from '@/configs/config';
import Activity from './containers/Activity';
import Bonaqua from './bonaqua';
import Georgia from './georgia';
import Edm202209 from './edm202209';
import Edm202210 from './edm202210';
import Edm202211 from './edm202211';
import Edm202212 from './edm202212';
import Edm202302 from './edm202302';
import Edm202304Tpe from './edm202304Tpe';
import Edm202304Hsz from './edm202304Hsz';
import Edm202305Tpe from './edm202305Tpe';
import Edm202305 from './edm202305';
import Directwines from './directwines';
import Ooha from './ooha';
import Newuser from './new_user';
import Ezcater from './ezcater';
import Edm202306 from './edm202306';
import Menu from './menu';
import Edm202307 from './edm202307';
import Drinks from './drinks';
import Edm202308 from './edm202308';
import MoonFestival2023 from './moonFestival2023';

export default () => {
  const theme = createMuiTheme({});
  return (
    <ThemeProvider theme={theme}>
      <Switch>
        {config.BrandNameEN === 'FreeZone' && (
        <>
          <Route path="/activity/bonaqua" component={Bonaqua} />
          <Route path="/activity/georgia" component={Georgia} />
          <Route path="/activity/directwines" component={Directwines} />
          <Route path="/activity/edm202209" component={Edm202209} />
          <Route path="/activity/edm202210" component={Edm202210} />
          <Route path="/activity/edm202211" component={Edm202211} />
          <Route path="/activity/edm202212" component={Edm202212} />
          <Route path="/activity/edm202302" component={Edm202302} />
          <Route path="/activity/edm202304_tpe" component={Edm202304Tpe} />
          <Route path="/activity/edm202304_hsz" component={Edm202304Hsz} />
          <Route path="/activity/edm202305_tpe" component={Edm202305Tpe} />
          <Route path="/activity/edm202305" component={Edm202305} />
          <Route path="/activity/ooha" component={Ooha} />
          <Route path="/activity/new_user" component={Newuser} />
          <Route path="/activity/ezcater" component={Ezcater} />
          <Route path="/activity/edm202306" component={Edm202306} />
          <Route path="/activity/menu" component={Menu} />
          <Route path="/activity/edm202307" component={Edm202307} />
          <Route path="/activity/drinks" component={Drinks} />
          <Route path="/activity/edm202308" component={Edm202308} />
          <Route path="/activity/2023-moon-festival" component={MoonFestival2023} />
        </>
        )}
        <Route path="/activity/:activityUrl" component={Activity} />
        <Redirect to="/" />
      </Switch>
    </ThemeProvider>
  );
};
